import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "mb-13 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-2hx fw-bolder mb-5" }, "Select Your Profile Type", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, " Access a curated ecosystem of Investors, industry experts and investment opportunities ", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-gray-400 fw-bold fs-5"
}
const _hoisted_6 = { class: "row g-10" }
const _hoisted_7 = { class: "card card-bordered mb-5" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "mb-7 mt-7 text-center" }
const _hoisted_11 = {
  class: "text-dark mb-5 fw-boldest",
  style: {"text-transform":"capitalize"}
}
const _hoisted_12 = {
  style: {"font-size":"13px"},
  class: "text-gray-400 fw-bold"
}
const _hoisted_13 = {
  class: "card-body",
  style: {"height":"183px"}
}
const _hoisted_14 = { class: "d-flex align-items-center mb-5" }
const _hoisted_15 = { class: "fw-bold fs-6 text-gray-800 flex-grow-1 pe-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 svg-icon-success" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.3",
      x: "2",
      y: "2",
      width: "20",
      height: "20",
      rx: "10",
      fill: "black"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z",
      fill: "black"
    })
  ])
], -1)
const _hoisted_17 = { class: "card-footer text-center" }
const _hoisted_18 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (!_ctx.isAnyRoleSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Choose one (or more) of the following roles to unleash the full potential of Emerture "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
        return (_openBlock(), _createElementBlock("div", {
          key: role.id,
          class: "col-xl-4"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h1", _hoisted_11, _toDisplayString(role.name), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(role.description), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.op.get(role, 'roleFeatures', []), (feature) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: feature.id,
                  class: "w-100 mb-10"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(feature.name), 1),
                    _hoisted_16
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                disabled: 
                _ctx.isRoleAttached(role.id) == 0 ||
                _ctx.isRoleAttached(role.id) == 1 ||
                _ctx.isRoleAttached(role.id) == 2
                  ? true
                  : false
              ,
                class: _normalizeClass([
                'btn',
                'btn-sm',
                _ctx.isRoleAttached(role.id) == 0
                  ? 'btn-secondary'
                  : _ctx.isRoleAttached(role.id) == 1
                  ? 'btn-primary'
                  : _ctx.isRoleAttached(role.id) == 2
                  ? 'btn-danger'
                  : 'btn-primary',
              ]),
                onClick: ($event: any) => (_ctx.attachRole(role.id))
              }, _toDisplayString(_ctx.isRoleAttached(role.id) == 0
                  ? "Awaiting Approval"
                  : _ctx.isRoleAttached(role.id) == 1
                  ? "Approved"
                  : _ctx.isRoleAttached(role.id) == 2
                  ? "Rejected"
                  : "Get Started"), 11, _hoisted_18)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}